import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import DeliverTo from 'components/FrictionlessCheckout/DeliverTo/DeliverTo';
import addressListSelector from 'selectors/order/addressListSelector';
import userUtils from 'utils/User';
import { getAddressList } from 'services/Checkout';
import { orderSelector } from 'selectors/order/orderSelector';
import orderErrorsSelector from 'selectors/order/orderErrorsSelector';
import PreferredZipCodeSelector from 'selectors/user/preferredZipCodeSelector';
const { preferredZipCodeSelector } = PreferredZipCodeSelector;
import ShipAddressActions from 'actions/ShipAddressActions';
import Empty from 'constants/empty';
import { SECTION_NAMES } from 'constants/frictionlessCheckout';
import OrderActions from 'actions/OrderActions';
import { orderDetailsSelector } from 'selectors/order/orderDetails/orderDetailsSelector';
import historyLocationActions from 'actions/framework/HistoryLocationActions';
import { refreshCheckout } from 'services/Checkout';

import DeliverToEN from 'components/FrictionlessCheckout/DeliverTo/locales/DeliverTo_en_US';
import DeliverToFR from 'components/FrictionlessCheckout/DeliverTo/locales/DeliverTo_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource, isCanada } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(DeliverToEN, DeliverToFR);

const halOperatingHoursSelector = createSelector(orderSelector, order => order.halOperatingHours || Empty.Array);

const loadUserAddressList = () => {
    if (!userUtils.isAnonymous()) {
        const profileId = userUtils.getProfileId();
        const shipCountry = userUtils.getShippingCountry().countryCode;
        getAddressList(profileId, shipCountry);
    }
};

const localization = createStructuredSelector({
    getItShippedTitle: getTextFromResource(getText, 'gisTitle'),
    sDDAndGISOrders: getTextFromResource(getText, 'sDDAndGISOrders'),
    gISAndAROrders: getTextFromResource(getText, 'gISAndAROrders'),
    sDDAndAROrders: getTextFromResource(getText, 'sDDAndAROrders'),
    sDDAndGISAndAROrders: getTextFromResource(getText, 'sDDAndGISAndAROrders'),
    holdAtLocation: getTextFromResource(getText, isCanada() ? 'holdAtLocationCA' : 'holdAtLocation')
});

const normalizeZip = zip => (zip || '').replace(/[^0-9A-Z]/gi, '');

const filterAddressByPreferredZipCode = (preferredZipCode, addressList) => {
    const sliceNumber = isCanada() ? 3 : 5;
    const normPref = normalizeZip(preferredZipCode).slice(0, sliceNumber);

    return addressList.filter(address => {
        const normAddr = normalizeZip(address.postalCode).slice(0, sliceNumber);

        return normPref === normAddr;
    }).length;
};

const fields = createSelector(
    localization,
    addressListSelector,
    halOperatingHoursSelector,
    preferredZipCodeSelector,
    orderErrorsSelector,
    orderDetailsSelector,
    (_ownState, ownProps) => ownProps.isSdd,
    (_ownState, ownProps) => ownProps.hasSDUOnlyInSddBasket,
    (locale, addressList, halOperatingHours, preferredZipCode, sectionErrors, orderDetails, isSdd, hasSDUOnlyInSddBasket) => {
        const deliverToSectionError = sectionErrors?.[SECTION_NAMES.DELIVER_TO];
        const sectionLevelError =
            (deliverToSectionError?.length || (typeof deliverToSectionError === 'boolean' && deliverToSectionError)) && deliverToSectionError;

        return {
            localization: locale,
            addressList,
            halOperatingHours,
            orderDetails,
            ...(isSdd && !hasSDUOnlyInSddBasket && { addressByPreferredZipCode: filterAddressByPreferredZipCode(preferredZipCode, addressList) }),
            sectionLevelError,
            sectionName: SECTION_NAMES.DELIVER_TO
        };
    }
);

const utilityFunctions = {
    loadUserAddressList,
    getAddressBook: ShipAddressActions.getAddressBook,
    updateShippingAddress: ShipAddressActions.updateShippingAddress,
    setActiveSection: OrderActions.setCheckoutActiveSection,
    refreshCheckout
};

const functions = {
    goToURL: historyLocationActions.goTo
};

const withDeliverToProps = wrapHOC(
    connect(fields, functions, (stateProps, dispatchProps, ownProps) => ({
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        ...utilityFunctions
    }))
);

export default withDeliverToProps(DeliverTo);
